<template>
  <modal
    class="commercial-terms-modal"
    name="participant-commercial-terms-modal"
    @before-open="handleBeforeOpen"
    @before-close="handleBeforeClose"
    transition="fade"
    :adaptive="true"
    :scrollable="true"
    :reset="true"
    width="50%"
    height="auto"
    style="z-index: 4100;"
  >
    <div id="modal-header" style="background-color:#006BE6">
      <div class="w-75 d-flex text-white">
        <p>Առևտրային պայմաններ {{ terms.name ? `- ${terms.name}` : '' }}</p>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 25%"
              @click="$modal.hide('participant-commercial-terms-modal')" aria-label="Close">
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 1.64102L14.859 0L8.49997 6.359L2.14102 4.62582e-05L0.5 1.64107L6.85895 8.00002L0.500034 14.3589L2.14105 16L8.49997 9.64104L14.8589 16L16.5 14.359L10.141 8.00002L16.5 1.64102Z" fill="#ffffff"/>
        </svg>
      </button>
    </div>
    <div id="modal-body" class="p-4">
      <div class="mb-3 p-3 bg-light br-8">
        <div class="font-size-13 text-secondary mb-1">Վճարման պայմաններ</div>
        <div class="font-size-15 font-weight-500 text-dark text-break" style="white-space: pre-line;">{{ terms.postpayment_condition || '-' }}</div>
      </div>

      <div class="mb-3 p-3 bg-light br-8">
        <div class="font-size-13 text-secondary mb-1">Կանխավճար և պայմաններ</div>
        <div class="font-size-15 font-weight-500 text-dark text-break" style="white-space: pre-line;">{{ terms.prepayment_condition || 'Կանխավճար նախատեսված չէ' }}</div>
      </div>

      <div class="mb-3 p-3 bg-light br-8">
        <div class="font-size-13 text-secondary mb-1">Մատակարարման պայմաններ (Պատվերը ստանալուց)</div>
        <div class="font-size-15 font-weight-500 text-dark text-break" style="white-space: pre-line;">{{ terms.delivery_condition || '-' }}</div>
      </div>

      <div :class="(terms.contract_status) ? 'mb-3' : 'mb-0'" class="p-3 bg-light br-8">
        <div class="font-size-13 text-secondary mb-1">Առաքման տեսակ</div>
        <div class="font-size-15 font-weight-500 text-dark text-break" style="white-space: pre-line;">{{ terms.delivery_type || '-' }}</div>
      </div>

      <div v-if="terms.contract_status" class="p-3 bg-light br-8">
        <div class="font-size-13 text-secondary mb-1">Պայմանագիր</div>
        <div class="font-size-15 font-weight-500 text-dark text-break">{{ contractStatusLabel }}</div>
        <div v-if="terms.contract_comment" class="mt-2">
          <div class="font-size-13 text-secondary mb-1">Դիտողություն</div>
          <div class="font-size-15 font-weight-500 text-dark text-break" style="white-space: pre-line;">{{ terms.contract_comment }}</div>
        </div>
        <div v-if="terms.contract_file" class="mt-2">
          <a :href="terms.contract_file" download target="_blank" class="btn btn-white border text-primary d-inline-flex align-items-center br-8">
            <svg class="mr-2" width="20" height="20" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.91797 19.1429C4.91797 20.0357 5.63225 20.75 6.52511 20.75H18.9358C19.8287 20.75 20.543 20.0357 20.543 19.1429V4.85714C20.543 3.96429 19.8287 3.25 18.9358 3.25H6.52511C5.63225 3.25 4.91797 3.96429 4.91797 4.85714V19.1429ZM19.1144 19.3214H6.34654V4.67857H19.1144V19.3214ZM8.75728 7.08943H16.793V8.518H8.75728V7.08943ZM16.793 15.482H8.75728V16.9106H16.793V15.482ZM8.75728 11.2857H16.793V12.7143H8.75728V11.2857Z" fill="#006BE6"/>
            </svg>
            <span>{{ contractFileName }}</span>
          </a>
        </div>
      </div>

      <div v-if="!_.isEmpty(terms.is_ameria_client)" class="mb-0 p-3 bg-light br-8">
        <div class="font-size-13 text-secondary mb-1">Արդյո՞ք Ձեր կազմակերպությունը հանդիսանում է Ամերիաբանկի հաճախորդ</div>
        <div class="font-size-15 font-weight-500 text-dark text-break">{{ String(terms.is_ameria_client) === '1' ? 'Այո' : 'Ոչ' }}</div>
      </div>
    </div>
    <div id="modal-footer" class="p-3 text-right">
      <button type="button" @click="$modal.hide('participant-commercial-terms-modal')" class="btn btn-secondary br-8">
        <span>Փակել</span>
      </button>
    </div>
  </modal>
</template>

<script>
import { CONTRACT_STATUS, PARTICIPANT_DATA_ADDITIONAL } from '@/constants/organisation';

export default {
  name: 'CommercialTermsModal',
  data() {
    return {
      CONTRACT_STATUS,
      PARTICIPANT_DATA_ADDITIONAL,
      terms: {
        name: '',
        postpayment_condition: '',
        prepayment_condition: '',
        delivery_condition: '',
        delivery_type: '',
        contract_status: null,
        contract_comment: '',
        contract_file: '',
        is_ameria_client: null,
      }
    }
  },
  computed: {
    contractStatusLabel() {
      switch (Number(this.terms.contract_status)) {
        case CONTRACT_STATUS.FULL:
          return 'Ամբողջությամբ ընդունում եմ պայմանագիրը';
        case CONTRACT_STATUS.PARTIAL:
          return 'Ընդունում եմ մասամբ';
        case CONTRACT_STATUS.REJECTED:
          return 'Չեմ ընդունում պայմանագիրը';
        default:
          return '-';
      }
    },
    contractFileName() {
      if (!this.terms.contract_file) return '';
      const parts = this.terms.contract_file.split('/');
      return parts[parts.length - 1] || 'Կցված փաստաթուղթ';
    },
  },
  methods: {
    handleBeforeOpen({ params }) {
      const participant = (params && (params.participant || params)) || {};
      const pData = (participant.participant && participant.participant[0]) || {};
      this.terms = {
        name: participant.name || '',
        postpayment_condition: pData.postpayment_condition || '',
        prepayment_condition: pData.prepayment_condition || '',
        delivery_condition: pData.delivery_condition || '',
        delivery_type: pData.delivery_type || '',
        contract_status: pData.contract_status ? Number(pData.contract_status) : null,
        contract_comment: pData.contract_comment || '',
        contract_file: pData.contract_file || '',
        is_ameria_client: pData?.additionals?.[PARTICIPANT_DATA_ADDITIONAL.IS_AMERIA_CLIENT] ?? null,
      };
    },
    handleBeforeClose() {
      this.terms = {
        name: '',
        postpayment_condition: '',
        prepayment_condition: '',
        delivery_condition: '',
        delivery_type: '',
        contract_status: null,
        contract_comment: '',
        contract_file: '',
        is_ameria_client: null,
      };
    }
  }
}
</script>

<style scoped>
.br-8 {
  border-radius: 8px;
}
</style>
